import React, { useEffect, lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import Label from 'components/ui/form/label';
import FormFeedback from 'components/ui/form/form_feedback';
import 'quill-paste-smart';
import './wysiwyg_input.scss';
import 'react-quill-new/dist/quill.snow.css';
import FormGroup from 'components/ui/form/form_group';

const ReactQuillLazy = lazy(async () => {
  const ReactQuill = await import('react-quill-new');
  return ReactQuill;
});

const cleanLiquidTags = (html) => {
  if (!html) return html;
  return html.replace(/(\{[%{])(.*?)([%}]\})/gs, (match, open, content, close) => {
    return (
      open +
      content
        .replace(/&nbsp;/g, ' ')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'") +
      close
    );
  });
};

const FormWysiwigInput = ({ label, input, meta: { error }, ...otherProps }) => {
  const handleChange = (content, delta, source) => {
    if (source !== 'user') return;
    input.onChange(cleanLiquidTags(content));
  };

  return (
    <FormGroup>
      {label && <Label>{label}</Label>}
      <Suspense fallback={<div>Loading...</div>}>
        <ReactQuillLazy theme="snow" value={input.value} onChange={handleChange} {...otherProps} />
      </Suspense>
      {error && <FormFeedback>{error.join(', ')}</FormFeedback>}
    </FormGroup>
  );
};

FormWysiwigInput.defaultProps = {
  label: null,
  type: 'text',
  placeholder: null,
};

FormWysiwigInput.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  input: PropTypes.object.isRequired,
  placeholder: PropTypes.string,
  meta: PropTypes.object.isRequired,
};

export default FormWysiwigInput;
